import { render, staticRenderFns } from "./404.vue?vue&type=template&id=e79498ec&scoped=true"
import script from "./404.vue?vue&type=script&lang=tsx"
export * from "./404.vue?vue&type=script&lang=tsx"
function injectStyles (context) {
  
  var style0 = require("./404.vue?vue&type=style&index=0&id=e79498ec&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e79498ec",
  "59e9172e"
  
)

export default component.exports